import React from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { DLS_TEXT_VARIANTS } from "constants/dls";
import {
    BenefitsSection as BenefitsSectionStyled,
    BenefitsCardsWrapper,
    BenefitsRow,
    BenefitCard,
    BenefitCardBackground,
    BenefitCardContent,
    BenefitCardTitle,
    BenefitCardSubtitle,
    BenefitIconWrapper,
    BenefitIcon,
} from "./styles";

interface BenefitsSectionProps {
    benefitsData: Array<{
        id: string;
        title: string;
        subtitle: string;
        icon: string;
    }>;
}

export const BenefitsSection: React.FC<BenefitsSectionProps> = ({ benefitsData }) => {
    return (
        <BenefitsSectionStyled>
            <Text variant="V2.heading1.neutral.bold" color="positive">
                We care for you!
            </Text>
            <BenefitsCardsWrapper>
                <BenefitsRow>
                    {benefitsData.map((benefit) => (
                        <BenefitCard key={benefit.id}>
                            <BenefitIconWrapper>
                                <BenefitIcon src={benefit.icon} alt="" />
                            </BenefitIconWrapper>
                            <BenefitCardBackground />
                            <BenefitCardContent>
                                <BenefitCardTitle>
                                    <Text variant="V2.heading2.neutral.bold" color="positive">
                                        {benefit.title}
                                    </Text>
                                </BenefitCardTitle>
                                <BenefitCardSubtitle>
                                    <Text variant="V2.heading2.neutral.bold" color="positive">
                                        {benefit.subtitle}
                                    </Text>
                                </BenefitCardSubtitle>
                            </BenefitCardContent>
                        </BenefitCard>
                    ))}
                </BenefitsRow>
            </BenefitsCardsWrapper>
        </BenefitsSectionStyled>
    );
};
